import { Routes, Route } from "react-router-dom";
import Login from "./components/Login/Login";
import Layout from "./components/Layout/Layout";
import CargaCliente from "./components/CargaCliente/CargaCliente";
import VerClientes from "./components/VerClientes/VerClientes";
import CargaServicio from "./components/CargarServicio/CargarServicio";
import VerServicios from "./components/VerServicios/VerServicios";
import EditarServicio from "./components/EditarServicio/EditarServicio";
import { Toaster } from "react-hot-toast";


function App() {
  return (
    <>
      {/* 🔔 Toaster global (fuera del enrutador para estar siempre activo) */}
      <Toaster
        position="top-right" // Es más estándar en apps profesionales que "top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#ffffff",
            color: "#1e293b", // Slate-800
            fontSize: "13px",
            fontWeight: "600",
            borderRadius: "12px",
            padding: "12px 16px",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", // Sombra suave
            border: "1px solid #f1f5f9", // Borde sutil slate-100
          },
          success: {
            iconTheme: {
              primary: "#2563eb", // El azul de tu navbar
              secondary: "#ffffff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444", // Rojo suave
              secondary: "#ffffff",
            },
            style: {
              border: "1px solid #fee2e2", // Borde rojo muy sutil para errores
            }
          },
        }}
      />

      <Routes>
        {/* 🔑 Rutas públicas */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* 🔐 Rutas protegidas (dentro del Layout) */}
        <Route path="/layout" element={<Layout />}>
          {/* 👇 Estas rutas se renderizan dentro de <Outlet /> */}

          <Route index element={<CargaServicio />} />
          <Route path="carga-cliente" element={<CargaCliente />} />
          <Route path="ver-clientes" element={<VerClientes />} />
          <Route path="carga-servicio" element={<CargaServicio />} />
          <Route path="ver-servicios" element={<VerServicios />} />
          <Route path="editar-servicio/:id" element={<EditarServicio />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
